import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  GetListOfQrCodes() {
    return Api().get(`/api/qr/get-qrcodes`);
  },
  GetQrCode(payload) {
    return Api().get(`/api/qr/get-qrcodes?QRcodeID=${payload}`);
  },
  GetQrCodeMovieList() {
    return Api().get(`/api/qr/get-qrcodes-movies-list`);
  },
  UpdateQrCode(payload) {
    return Api().post(`/api/qr/update-qrcodes`, payload);
  }
};



// WEBPACK FOOTER //
// ./src/services/QrService.js